import React from 'react'

export default class Radio extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        var classes = 'radio-container'
        if (this.props.className) {
            classes += ' ' + this.props.className
        }
        if (this.props.disabled) {
            classes += ' disabled'
        }
        return (
            <label className={classes} style={this.props.style}>
                {!this.props.right && this.props.label}
                {this.props.disabled && (
                    <input
                        type='radio'
                        name={this.props.name}
                        value={this.props.value}
                        checked={this.props.checked}
                        aria-disabled
                    />
                )}
                {!this.props.disabled && (
                    <input
                        type='radio'
                        name={this.props.name}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        checked={this.props.checked}
                    />
                )}
                <div
                    className={'checkmark ' + (this.props.checked ? 'checkmark-selected' : '')}
                    style={this.props.radioStyle}
                >
                    {this.props.checked && (
                        <div className='radio-button-inner'>
                            <div className='radio-button-inner-white'></div>
                        </div>
                    )}
                </div>
                {!!this.props.right && this.props.label}
                {this.props.children}
            </label>
        )
    }
}
